import { BirthDateField } from '@/components/form/BirthDateField';
import { GenderField } from '@/components/form/GenderField';
import { InputField } from '@/components/form/InputField';
import { PhoneInputField } from '@/components/form/PhoneInputField';
import type { PersonDataField } from '@/hooks/usePersonFieldRenderer';
import { TransText } from '@/i18n/trans/text';
import { cn } from '@/utils/cn';
import type { FC } from 'react';
import { useCallback } from 'react';

interface PassengerInfoProps {
  formFields: Array<PersonDataField>;
  prefix: string;
  ['data-testid']?: string;
}

const PassengerInfo: FC<PassengerInfoProps> = ({
  formFields,
  prefix,
  ...rest
}) => {
  const renderField = useCallback(
    (field: PersonDataField) => {
      const { name, isRequired } = field;

      const baseProps = {
        name: `${prefix}.${name}`,
        label: <TransText i18nKey={name} />,
        required: isRequired,
        classNames: {
          wrapper: cn({
            'tablet:col-span-2':
              name.toUpperCase().includes('PHONE') ||
              name.toUpperCase().includes('EMAIL'),
          }),
        },
      };

      if (name.toUpperCase().includes('PHONE')) {
        return <PhoneInputField key={name} {...baseProps} />;
      }

      if (name === 'birthDate') {
        return <BirthDateField key={name} {...baseProps} />;
      }

      if (name === 'gender') {
        return (
          <GenderField
            key={name}
            genderOptionsType="passenger"
            {...baseProps}
          />
        );
      }

      return <InputField key={name} {...baseProps} />;
    },
    [prefix]
  );

  return (
    <div
      {...rest}
      className="grid grid-cols-1 gap-2 rounded-sm border border-neutral-light bg-primary-pale p-3 pb-4 tablet:flex-[2] tablet:grid-cols-2 tablet:gap-4 tablet:p-4 tablet:pt-3"
    >
      {formFields.map((field) => renderField(field))}
    </div>
  );
};

export default PassengerInfo;
